import {
    currencyFormatter,
    currencyFormatterOrEmDash,
    dateFormatter,
    orderNumberFormatter,
    productFormatter,
    sharesFormatter
} from './formatters';

export class GridUtils {
    static formatters = {
        productFormatter,
        currencyFormatter,
        currencyFormatterOrEmDash,
        orderNumberFormatter,
        dateFormatter,
        sharesFormatter
    };
}
